import styled from "styled-components"

export const MinimizedLayoutRoot = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
`
